import { createAxios } from './createAxios'
import { Message } from 'element-ui'

import store from '@/store'

// service 循环遍历输出不同的请求方法
const instance = createAxios()

// 拦截器
instance.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  if (store.getters.getToken) {
    config.headers['Authorization'] = store.getters.getToken // 让每个请求携带自定义token
  }
  return config
}, () => {
  Message('请求错误，请稍后重试')
})

instance.interceptors.response.use(res => {
  return res.data
}, (err) => {
  console.error(err)
})

export const Instance = instance
